var SAC_XHR_LOAD_ERROR = 'SAC_XHR_LOAD_ERROR';
var XHR_LOAD_ERROR = 'Uh oh. Something’s crashed. Sorry - we’re working on it. Please check back soon.';
export { XHR_LOAD_ERROR, SAC_XHR_LOAD_ERROR };